<template>
  <div v-if="applicationDetails.deposit.toLowerCase() === 'pending'">
    <h5>Deposit Payment</h5>
    <p>
      In order to complete the application, there is a
      ${{ sessionDetails.depositAmount }} deposit payment.
    </p>
    <q-btn
      @click="payDepositClick"
      color="primary"
      label="Pay deposit through external link"
      class="q-ml-sm"
    />
  </div>
  <div v-else>
    <h5>Deposit Payment</h5>
    <p>Deposit for this application has already been paid.</p>
  </div>
</template>

<script>
import { useRoute } from 'vue-router';
import usePayment from '@/hooks/payment';
import useApplication from '@/hooks/application';
import useSession from '@/hooks/session';

export default {
  async setup() {
    const route = useRoute();
    const { payDeposit } = usePayment();
    const {
      applicationDetails,
      getApplication,
    } = useApplication();

    const {
      sessionDetails,
      fetchSession,
    } = useSession();

    await getApplication(route.params.applicationId);

    if (!applicationDetails.value.deposit) {
      await fetchSession(applicationDetails.value.sessionId, true);
    }

    const payDepositClick = () => {
      payDeposit(route.params.applicationId);
    };

    return {
      payDepositClick,
      sessionDetails,
      applicationDetails,
    };
  },
};
</script>
